import React from "react";
import EditorShell from "../EditorShell";
import { TextField } from "../fields";
import { footerSchema, SECTION_DEFAULTS } from "../schemas";

const FooterEditor = ({ section, onSaved, onLiveChange }) => (
  <EditorShell
    sectionKey="footer"
    schema={footerSchema}
    defaults={SECTION_DEFAULTS.footer}
    section={section}
    onSaved={onSaved}
    onLiveChange={onLiveChange}
  >
    {(form) => (
      <>
        <TextField
          form={form}
          path="sponsor_line"
          label="Sponsor line"
          required
          hint='e.g. "Sponsored by Jackson Health System"'
        />
        <TextField
          form={form}
          path="copyright_line"
          label="Copyright line"
          hint='e.g. "© 2026 Aris"'
        />
      </>
    )}
  </EditorShell>
);

export default FooterEditor;
